import {Model} from '../base.model';

export class TireWheel extends Model {
  description: string;
  radius: string;
  weight: number;
  type: 'Tires'|'Wheels';
  isTruck = false;
}
